import { captureException, setContext } from "@sentry/vue"
import { setupApi } from "~ui/utils/api"

function isObjectWithUnknownValues(
  value: unknown,
): value is { [key: string]: unknown } {
  return typeof value === "object" && value !== null && !Array.isArray(value)
}

export default setupApi({
  csrfEndpoint: "/auth/csrf",
  onRequest: ({ headers, isCsrfOnly }) => {
    if (isCsrfOnly) return

    const csrf = useCookie("XSRF-TOKEN")
    const { token } = useAuth()

    if (token.value) {
      headers.set("Authorization", `Bearer ${token.value}`)
    }
    if (csrf.value) {
      headers.set("X-XSRF-TOKEN", csrf.value)
    }
  },
  onResponseError: async ({ response }) => {
    const redirectedToLogin =
      response.redirected &&
      response.headers.get("location")?.includes("/login")

    if (response.status === 401 || redirectedToLogin) {
      const { logout } = useAuth()
      await logout()
    }
  },
  onRequestError: async ({ request, error }) => {
    const context = { request, error }
    if (isObjectWithUnknownValues(context)) {
      setContext("error_context", context)
    }
    if (context.error) {
      captureException(context.error)
    } else {
      captureException("Unknown fetch request error")
    }
  },
})
